module.exports = __webpack_public_path__ + "static/images/containers/ClanLanding/images/global_map_bg_with_news_with_quests.b6135937.jpg";


//////////////////
// WEBPACK FOOTER
// ./containers/ClanLanding/images/global_map_bg_with_news_with_quests.jpg
// module id = 2982
// module chunks = 11